import ms from 'ms'
import { useQuery } from 'react-query'
import { UseQueryResult } from 'react-query/types/react/types'
import { getRawLayerAvailable } from './api'

/**
 * Whether the raw (unmasked) crop layer is available for a run. Internal-only at
 * the API. Returns false while loading / when unavailable so callers can safely
 * gate the raw-crop toggle on the resolved value.
 *
 * Replaces the hardcoded run allowlist: the raw-crop toggle is offered on every
 * run for internal users, and this signal decides whether it is enabled.
 */
export default function useRawLayerAvailable(
  runId: string | undefined | null,
  enabled = true
): UseQueryResult<boolean, unknown> {
  return useQuery(
    ['rawLayerAvailable', runId],
    async () => {
      if (!runId) return false
      return getRawLayerAvailable(runId)
    },
    {
      enabled: enabled && !!runId,
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: ms('1 hour'),
      staleTime: ms('1 hour'),
    }
  )
}
